

export const AbilityInfo = (props) => {

    return (
        <>
            <p>Beep boop, ability snoop!</p>
        </>
    );
};
